module.exports = __webpack_public_path__ + "media/images/prize__shirt-c22e4dab74f4411635ccd1d0bc55cea6.jpg";